import React from 'react';
import { Card, Form, Input, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

interface Props {
  startNo: string;
  endNo: string;
  loading: boolean;
  onStartChange: (v: string) => void;
  onEndChange: (v: string) => void;
  onSearch: () => void;
}

const Pwd216QueryBar: React.FC<Props> = React.memo(
  ({ startNo, endNo, loading, onStartChange, onEndChange, onSearch }) => {
    const handleKeyDown = (e: React.KeyboardEvent) => {
      if (e.key === 'Enter') onSearch();
    };

    return (
      <Card size="small" style={{ marginBottom: 12 }}>
        <Form layout="inline" size="small">
          <Form.Item label={<span data-contract-field="query_doc_start">起始單號</span>}>
            <Input
              value={startNo}
              onChange={(e) => onStartChange(e.target.value)}
              placeholder="例：D24001"
              style={{ width: 140 }}
              onKeyDown={handleKeyDown}
            />
          </Form.Item>
          <Form.Item label={<span data-contract-field="query_doc_end">結束單號</span>}>
            <Input
              value={endNo}
              onChange={(e) => onEndChange(e.target.value)}
              placeholder="例：D24099"
              style={{ width: 140 }}
              onKeyDown={handleKeyDown}
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={onSearch}
              loading={loading}
            >
              確定範圍
            </Button>
          </Form.Item>
        </Form>
      </Card>
    );
  },
);

Pwd216QueryBar.displayName = 'Pwd216QueryBar';
export default Pwd216QueryBar;
